<h4 mat-dialog-title>Ajouter un type AAP</h4>
<mat-dialog-content>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-lg-12">
        <fieldset class="form-group">
          <label for="inputLabel">Libellé <span class="star">*</span></label>
          <input formControlName="label" type="text" id="inputLabel" required class="form-control">
          @if (label.invalid && (label.dirty || label.touched)) {
            <p>
              @if (label.errors.required) {
                <small class="danger text-muted">* Ce champs est requis</small>
              }
            </p>
          }

        </fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <fieldset class="form-group">
          <label for="inputCode">Code <span class="star">*</span></label>
          <input formControlName="code" type="text" id="inputCode" required class="form-control"  (keydown)="removeSpecialChar($event)">
          @if (code.invalid && (code.dirty || code.touched)) {
            <p>
              @if (code.errors.required) {
                <small class="danger text-muted">* Ce champs est requis</small>
              }
            </p>
          }
        </fieldset>
      </div>
    </div>

  </form>
  <div class="row">
    <div class="col-lg-12">
      <fieldset class="form-group">
        <label for="basicSelect">Catégorie AAP <span class="star">*</span></label>
        <select class="form-control" [(ngModel)]="typeAideSelected" required id="basicSelect">
          <!--<option selected="">Open this select menu</option>-->
          @for (row of typesAides; track row) {
            <option [value]="row.label">{{ row?.label }}</option>
          }
        </select>
      </fieldset>
    </div>
  </div>


</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" style="margin-right: 15px;">Annuler</button>
  <button mat-raised-button color="primary" type="submit" (click)="prepareForSave()">Ajouter</button>
</mat-dialog-actions>

